import { Button, Flex } from '@ifood/pomodoro-components';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { HOME_PAGE_CONTENT } from '@constants/element-ids';
import ScrollDownArrow from 'images/scroll-down-arrow.svg';
import { HOME_SPLASH_CONFIG } from 'modules/Home/constants';
import { Link } from 'modules/UI';

import {
  Action,
  Actions,
  CallOut,
  CallOutContent,
  Container,
  Description,
  ScrollDown,
  ScrollDownIcon,
  Title,
} from './styles';

const Splash: FC = () => {
  return (
    <Container>
      <Flex justifyContent="center">
        <CallOut>
          <CallOutContent>
            <Title>
              <FormattedMessage id={HOME_SPLASH_CONFIG.titleKey} />
            </Title>
            <Description>
              <FormattedMessage id={HOME_SPLASH_CONFIG.subtitleKey} />
            </Description>

            <ScrollDown>
              <Link dataTestId="mobile-scroll-down" href={`#${HOME_PAGE_CONTENT}`}>
                <ScrollDownIcon alt="" src={ScrollDownArrow} />
              </Link>
            </ScrollDown>
          </CallOutContent>
        </CallOut>
      </Flex>
    </Container>
  );
};
export default Splash;
